export default {
  width: state => state.width,
  height: state => state.height,
  scrollheight: state => state.scrollheight,
  progress: state => state.progress,
  getAll: state => {
    return state
  },
  isdevice: state => state.isdevice,
  getSize: state => {
    return {
      width: state.width,
      height: state.height,
      scrollheight: state.scrollheight
    }
  },
  mobile: state => state.mobile,
  small: state => state.small,
  scrolltocomplete: (state) => state.scrolltocomplete
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/viewport/getters.js